import { LanguageContext } from "../LanguageContext";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { strings } from "../l8n";
import LocalizedMessage from "../LocalizedMessage";
import HazzatFont from "./HazzatFont";
import MainPaper, { Size } from "./MainPaper";
import MyNavLink from "./MyNavLink";

function FontsPage() {

    const { languageProperties } = useContext(LanguageContext);
    useEffect(() => {
        document.title = strings.fonts + " - hazzat.com";
    }, [languageProperties.localeName]);

    return (
        <Routes>
            <Route path="/" element={
                <MainPaper size={Size.Wide}>
                    <h1 className="pageTitle"><LocalizedMessage of="hazzatFont" /></h1>
                    <div><strong><MyNavLink to="HazzatFont"><LocalizedMessage of="hazzatFontVer" /></MyNavLink></strong><br /> <LocalizedMessage of="hazzatFontDesc" /></div>

                    <h2 className="pageTitle" style={{ paddingTop: "40px" }}><LocalizedMessage of="copticFonts" /></h2>
                    <div><LocalizedMessage of="copticZipTitle" /></div>
                    <div style={{ paddingTop: "20px" }} dangerouslySetInnerHTML={{ __html: strings.copticZipContents }}></div>
                    <div style={{ textAlign: "center" }}>
                        <a href="/downloads/copticfonts.zip" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faDownload} className="text-dark" /> <LocalizedMessage of="downloadAllCopticFonts" />
                        </a>
                    </div>
                </MainPaper>
            } />
            <Route path={`/HazzatFont`} element={<HazzatFont />} />
        </Routes>
    );
}

export default FontsPage;
